import React from 'react';
import { useFakeToggleState } from '@wix/da-hooks/pkg/useFakeToggleState';
import MainToggle from '@wix/da-ds/pkg/formControls/dsPresets/MainToggle';
const MatureToggle = ({ id , value =false , onChange , size , 'aria-label': ariaLabel , 'aria-labelledby': ariaLabelledBy  })=>{
    const { onClick , toggleState  } = useFakeToggleState(value, onChange);
    return /*#__PURE__*/ React.createElement(MainToggle, {
        id: id,
        value: toggleState,
        onChange: onClick,
        size: size,
        "aria-label": ariaLabel,
        "aria-labelledby": ariaLabelledBy
    });
};
export default MatureToggle;
